import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SprinklerHeadSamplingPage from './SprinklerHeadSamplingPage';
const queryClient = new QueryClient();
export default function SprinklerHeadSampling() {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(SprinklerHeadSamplingPage, null)));
}
